import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { PLACEHOLDER } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';

import type { IGameType } from '@/pages/intelligence/types/common';

const MOBILE_METRICS: {
  [key: string]: string;
} = {
  revenue: 'dbi_revenue',
  downloads: 'dbi_downloads',
  mau: 'dbi_mau',
  wau: 'dbi_wau', // 无需使用，因仅有月粒度的数据
  dau: 'dbi_dau', // 无需使用，因仅有月粒度的数据
};

// 从PC情报移植过来，暂时没用统一的，不确定逻辑是否一致
export const valueFormat = (payload: string): string => {
  const numPayload = Number.parseFloat(payload);
  if (Number.isNaN(numPayload)) return PLACEHOLDER;
  if (numPayload >= 1000000) return `${(numPayload / 1000000).toFixed(1)}M`;
  if (numPayload >= 1000) return `${Math.round(numPayload / 1000).toFixed(1)}K`;
  return `${numPayload}`;
};

export const getSourcesIcons = (sources?: string[]): React.ReactElement[] => {
  const nodes: React.ReactElement[] = [];
  if (!Array.isArray(sources)) return [];
  for (const source of sources) {
    const sourceIcon = getDataSourceIcon(source);
    if (!sourceIcon) continue;
    // @ts-ignore
    nodes.push(<img src={sourceIcon} className="text-img" />);
  }
  return nodes;
};

export const getMetricName = (cfg: { entityType: IGameType; sources: string[]; metric: string }): string => {
  const { entityType, sources, metric } = cfg ?? {};
  if (!['mobile', 'pc', 'console'].includes(entityType)) return '';
  if (entityType === 'mobile') {
    return MOBILE_METRICS[metric] ?? 'dbi_revenue';
  }
  if (sources?.includes('steamcharts')) return 'dbi_pcu';
  if (sources?.includes('newzoo')) return 'dbi_mau';
  if (metric === 'pcu') {
    return 'dbi_pcu';
  }
  if (metric === 'acu') {
    return 'dbi_acu';
  }
  return 'dbi_revenue';
};
